import React from 'react';
import CadastroProducaoContent from './CadastroProducaoContent';
import { CadastroProducaoProvider } from './context/CadastroProducaoContext';

export const CadastroProducao: React.FC = () => {
  return (
    <CadastroProducaoProvider>
      <CadastroProducaoContent />
    </CadastroProducaoProvider>
  );
};
